module.exports = __webpack_public_path__ + "img/chinesecompany10.aa4c119d.png";